'use client'

import { useEffect, useState } from 'react'
import { withMarketingParams } from './applyToUrl'
import { captureFromCurrentUrl } from './store'

/**
 * Returns a stable href for SSR and the first client render, then appends
 * persisted marketing params after mount once browser attribution state is
 * available.
 */
export function useMarketingParamsHref(target: string): string {
  const [href, setHref] = useState(target)

  useEffect(() => {
    captureFromCurrentUrl()
    setHref(withMarketingParams(target))
  }, [target])

  return href
}

export default useMarketingParamsHref
